var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleClassroom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.81836 2.48486H18.182V16.1212H1.81836V2.48486Z",
    fill: "#0F9D58"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6373 9.75761C14.2016 9.75761 14.66 9.29928 14.66 8.73488C14.66 8.17049 14.2016 7.71216 13.6373 7.71216C13.0729 7.71216 12.6145 8.17049 12.6145 8.73488C12.6145 9.29928 13.0729 9.75761 13.6373 9.75761ZM13.6373 10.4394C12.5426 10.4394 11.3645 11.019 11.3645 11.7387V12.4849H15.91V11.7387C15.91 11.019 14.7319 10.4394 13.6373 10.4394ZM6.36452 9.75761C6.92892 9.75761 7.38725 9.29928 7.38725 8.73488C7.38725 8.17049 6.92892 7.71216 6.36452 7.71216C5.80013 7.71216 5.3418 8.17049 5.3418 8.73488C5.3418 9.29928 5.80013 9.75761 6.36452 9.75761ZM6.36452 10.4394C5.26983 10.4394 4.0918 11.019 4.0918 11.7387V12.4849H8.63725V11.7387C8.63725 11.019 7.45922 10.4394 6.36452 10.4394Z",
    fill: "#57BB8A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 8.84861C10.754 8.84861 11.3638 8.23876 11.3638 7.48497C11.3638 6.73119 10.754 6.12134 10.0002 6.12134C9.24639 6.12134 8.63654 6.73119 8.63654 7.48497C8.63654 8.23876 9.24639 8.84861 10.0002 8.84861ZM10.0002 9.7577C8.46609 9.7577 6.81836 10.5721 6.81836 11.5759V12.485H13.182V11.5759C13.182 10.5721 11.5343 9.7577 10.0002 9.7577Z",
    fill: "#F7F7F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8184 15.2122H15.9093V16.1212H11.8184V15.2122Z",
    fill: "#F1F1F1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6364 0.666748H1.36364C0.609849 0.666748 0 1.2766 0 2.03038V16.5758C0 17.3296 0.609849 17.9395 1.36364 17.9395H18.6364C19.3902 17.9395 20 17.3296 20 16.5758V2.03038C20 1.2766 19.3902 0.666748 18.6364 0.666748ZM18.1818 16.1213H1.81818V2.48493H18.1818V16.1213Z",
    fill: "#F4B400"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M18.6364 0.666748H1.36364C0.609849 0.666748 0 1.2766 0 2.03038V2.14402C0 1.39023 0.609849 0.780384 1.36364 0.780384H18.6364C19.3902 0.780384 20 1.39023 20 2.14402V2.03038C20 1.2766 19.3902 0.666748 18.6364 0.666748Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M18.6364 17.8258H1.36364C0.609849 17.8258 0 17.2159 0 16.4622V16.5758C0 17.3296 0.609849 17.9394 1.36364 17.9394H18.6364C19.3902 17.9394 20 17.3296 20 16.5758V16.4622C20 17.2159 19.3902 17.8258 18.6364 17.8258Z",
    fill: "#BF360C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9015 16.1213H11.8105L13.6287 17.9395H17.7159L15.9015 16.1213Z",
    fill: "url(#paint0_linear_9953_23210)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1.81836 2.37134H18.182V2.48497H1.81836V2.37134Z",
    fill: "#263238"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1.81836 16.1213H18.182V16.235H1.81836V16.1213Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6364 0.666748H1.36364C0.609849 0.666748 0 1.2766 0 2.03038V16.5758C0 17.3296 0.609849 17.9395 1.36364 17.9395H18.6364C19.3902 17.9395 20 17.3296 20 16.5758V2.03038C20 1.2766 19.3902 0.666748 18.6364 0.666748Z",
    fill: "url(#paint1_radial_9953_23210)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9953_23210",
    x1: 14.7634,
    y1: 16.1465,
    x2: 14.7634,
    y2: 17.9585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF360C",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF360C",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_9953_23210",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.588676 1.07162) scale(82.5201 82.5198)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleClassroom);
export default __webpack_public_path__ + "static/media/googleClassroom.b055dba6.svg";
export { ForwardRef as ReactComponent };